import React, { useState, useMemo, useEffect } from 'react';
import { X } from 'lucide-react';
import { Sheet, SheetContent } from '../../../components/ui/sheet';
import { useTranslation } from 'react-i18next';
import { CommentsThread } from '../Shared/CommentsThread';
import { getCommentsByModule, MOCK_COMMENTS } from '../../../utils/mockCommentsData';
import './CommentsDrawer.css';

const MODULES = [
  { id: 'all' },
  { id: 'm0', nameKey: 'reports.workspace.modules.m0.name' },
  { id: 'm1', nameKey: 'reports.workspace.modules.m1.name' },
  { id: 'm2', nameKey: 'reports.workspace.modules.m2.name' },
  { id: 'm3', nameKey: 'reports.workspace.modules.m3.name' },
  { id: 'm4', nameKey: 'reports.workspace.modules.m4.name' },
];

export function CommentsDrawer({ 
  isOpen, 
  onClose, 
  comments = [], 
  onAddComment, 
  onReply,
  onEdit,
  onDelete,
  onResolve,
  currentUser 
}) {
  const { t } = useTranslation();
  const [selectedModule, setSelectedModule] = useState('all');
  
  // Use mock comments if no comments provided
  const allComments = comments.length > 0 ? comments : MOCK_COMMENTS;
  
  const filteredComments = useMemo(() => {
    return getCommentsByModule(allComments, selectedModule);
  }, [allComments, selectedModule]);

  const handleAddComment = (text, moduleId = selectedModule) => {
    if (onAddComment) {
      onAddComment(text, moduleId);
    } else {
      // Mock: Add comment to local state
      console.log('Adding comment:', text, 'to module:', moduleId);
    }
  };

  // Debug logging
  React.useEffect(() => {
    console.log('CommentsDrawer isOpen:', isOpen);
  }, [isOpen]);

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="comments-drawer" style={{ width: '500px', zIndex: 1000 }}>
        {/* Header */}
        <div className="comments-drawer__header">
          <h2 className="comments-drawer__title">{t('reports.workspace.commentsDrawer.title')}</h2>
          <div className="comments-drawer__header-actions">
            <select
              className="comments-drawer__filter"
              value={selectedModule}
              onChange={(e) => setSelectedModule(e.target.value)}
            >
              {MODULES.map((module) => (
                <option key={module.id} value={module.id}>
                  {module.id === 'all'
                    ? t('reports.workspace.commentsDrawer.allModules')
                    : t('reports.workspace.moduleLabelShort', {
                        id: module.id.toUpperCase(),
                        name: t(module.nameKey),
                      })}
                </option>
              ))}
            </select>
            <button
              className="comments-drawer__close-btn"
              onClick={onClose}
              aria-label={t('common.close')}
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Comments Thread */}
        <CommentsThread
          comments={filteredComments}
          onAddComment={handleAddComment}
          onReply={onReply}
          onEdit={onEdit}
          onDelete={onDelete}
          onResolve={onResolve}
          currentUser={currentUser}
          selectedModule={selectedModule}
        />
      </SheetContent>
    </Sheet>
  );
}
